import { Component, computed, EventEmitter, input, Output } from '@angular/core';

export type FloatingNavigationButtonType = 'left' | 'right';

@Component({
  selector: 'app-floating-navigation-button',
  standalone: true,
  imports: [],
  templateUrl: './floating-navigation-button.component.html',
})
export class FloatingNavigationButtonComponent {
  public readonly type = input.required<FloatingNavigationButtonType>();

  public readonly icon = computed(() => {
    switch(this.type()) {
    case 'left':
      return '/assets/svg/chevron-left.svg';
    case 'right':
      return '/assets/svg/chevron-right.svg';
    }
  });

  @Output() public readonly clicked = new EventEmitter<void>();

  public onClick(): void {
    this.clicked.emit();
  }
}
